import React from 'react';

interface KPITrend {
	value: number;            // ej: -25.5
	label: string;            // ej: "vs semana pasada"
	positive_is_good?: boolean; // si true, +X es verde; si false, +X es rojo
}

interface KPICardProps {
	title: string;
	value: string | number;
	subtitle?: string;
	icon?: React.ReactNode;
	trend?: KPITrend;
	variant?: 'default' | 'success' | 'warning' | 'danger' | 'highlight';
	size?: 'small' | 'medium' | 'large';
	loading?: boolean;
}

const KPICard = (props: KPICardProps) => {
	const {
		title,
		value,
		subtitle,
		icon,
		trend,
		variant = 'default',
		size = 'medium',
		loading = false
	} = props;

	const renderTrend = () => {
		if (!trend) return null;

		const isUp = trend.value > 0;
		const isFlat = trend.value === 0;
		// positive_is_good por defecto true: subir = bueno (verde)
		const positiveIsGood = trend.positive_is_good !== false;
		const isGood = isFlat ? null : isUp === positiveIsGood;

		const trendClass = isFlat
			? 'flat'
			: isGood
				? 'good'
				: 'bad';

		const arrow = isFlat ? '→' : isUp ? '↑' : '↓';

		return (
			<div className={ `kpi-trend ${ trendClass }` }>
				<span className="kpi-trend-arrow">{ arrow }</span>
				<span className="kpi-trend-value">
					{ isUp ? '+' : '' }{ trend.value }%
				</span>
				<span className="kpi-trend-label">{ trend.label }</span>
			</div>
		);
	}

	return (
		<div className={ `kpi-card kpi-${ variant } kpi-${ size }` }>
			<p className="kpi-title">{ title }</p>

			<div className="kpi-value-row">
				{ icon && <span className="kpi-icon">{ icon }</span> }
				{
					loading ? (
						<span className="kpi-skeleton" aria-label="Cargando" />
					) : (
						<span className="kpi-value">{ value }</span>
					)
				}
			</div>

			{ subtitle && !loading && (
				<p className="kpi-subtitle">{ subtitle }</p>
			) }

			{ subtitle && loading && (
				<span className="kpi-skeleton kpi-skeleton-sub" aria-label="Cargando" />
			) }

			{ !loading && renderTrend() }
		</div>
	)
}

export default KPICard;
